import { ImageConfig, VendorStorageLocationType } from "@/types";

export function validateImageConfig(
  imageConfig: ImageConfig,
  vendorStorageLocationType: VendorStorageLocationType,
  selectedVendor?: { vendorName: string }
): string[] {
  const errors: string[] = [];

  // Required fields
  if (!imageConfig.vendorStorageLocation) {
    errors.push("vendorStorageLocation is required for Hosted Images.");
  }
  if (!imageConfig.nestingaleLocation) {
    errors.push("nestingaleLocation is required for Hosted Images.");
  } else {
    // Validate format
    const expectedPrefix = `s3://vendor-sftp-storage/${selectedVendor?.vendorName}`;
    if (!imageConfig.nestingaleLocation.startsWith(expectedPrefix)) {
      errors.push(
        `nestingaleLocation must start with "${expectedPrefix}", got "${imageConfig.nestingaleLocation}".`
      );
    }
  }
  if (!imageConfig.imgNameSyntax) {
    errors.push("imgNameSyntax is required for Hosted Images.");
  }


  if (vendorStorageLocationType === 'Dropbox') {
    if (!imageConfig.dropBox) {
      errors.push("dropBox config is required for Dropbox.");
    } else {
      const { type, folderColumnName, imagePattern, sharedFolderURL } =
        imageConfig.dropBox;

      if (type !== 'bySku' && type !== 'shared') {
        errors.push(`Invalid dropBox type: ${type}`);
      }

      if (type === 'bySku') {
        if (!folderColumnName) {
          errors.push("folderColumnName is required for 'Folder Structure By SKU'.");
        }
        if (!imagePattern) {
          errors.push("imagePattern is required for 'Folder Structure By SKU'.");
        }
      }

      if (type === 'shared') {
        if (!sharedFolderURL) {
          errors.push("sharedFolderURL is required for 'Shared Folder'.");
        }
      }
    }
  }

  return errors;
}
